import { Software, SoftwareVersion } from '../../api/api-generated';
import { stringIncludesIgnoreCaseIgnoreNullSubstring } from '../../utils/comparisons';
import { emailSignature } from '../lpt-rma/RmaUtils';
import { SoftwareVersionFilter, SoftwareVersionForm } from './linksTypes';

export const softwareVersionValidator = (item: SoftwareVersionForm) => {
  if (
    !item.versionNumber ||
    !item.link ||
    !item.size ||
    !item.software ||
    !item.operatingSystem
  )
    return false;
  return true;
};

export const filterSoftwareVersion = (
  item: SoftwareVersion,
  filters: SoftwareVersionFilter
) => {
  if (
    filters.software &&
    !stringIncludesIgnoreCaseIgnoreNullSubstring(
      item.software.type,
      filters.software.type
    )
  )
    return false;
  if (
    filters.operatingSystem &&
    !stringIncludesIgnoreCaseIgnoreNullSubstring(
      item.operatingSystem.osName,
      filters.operatingSystem.osName
    )
  )
    return false;
  if (
    filters.name &&
    !stringIncludesIgnoreCaseIgnoreNullSubstring(
      item.versionNumber,
      filters.name
    )
  )
    return false;
  return true;
};

export const versionsMiddleware = (
  name: string,
  value: string,
  state: any,
  autoboxValue?: object,
  autoboxLabel?: string
) => {
  if (autoboxLabel && autoboxLabel === 'software')
    return { software: autoboxValue };
  if (autoboxLabel && autoboxLabel === 'os')
    return { operatingSystem: autoboxValue };
  return {};
};

export const emailBuilder = (
  versionNumber: string,
  software: Software | undefined
) => {
  return `Greetings from LP Technologies. We're excited to announce the release of ${
    software?.type || '_______'
  } version ${versionNumber}!

To download the new version and unlock its features, go to the LP Technologies client portal at https://portal.lptapps.com.

Thank you for your continued business, and please feel free to contact us directly with any questions.

Best regards,
  
${emailSignature}`;
};
